/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GUFIds
 */
export interface GUFIds {
  /**
   *
   * @type {string}
   * @memberof GUFIds
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GUFIds
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GUFIds
   */
  deliveryAccountableParty?: string | null;
  /**
   *
   * @type {string}
   * @memberof GUFIds
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GUFIds interface.
 */
export function instanceOfGUFIds(value: object): value is GUFIds {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GUFIdsFromJSON(json: any): GUFIds {
  return GUFIdsFromJSONTyped(json, false);
}

export function GUFIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GUFIds {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    broId: json["bro_id"],
    deliveryAccountableParty:
      json["delivery_accountable_party"] === undefined
        ? undefined
        : json["delivery_accountable_party"] === null
        ? null
        : json["delivery_accountable_party"],
    dataOwner: json["data_owner"],
  };
}

export function GUFIdsToJSON(json: any): GUFIds {
  return GUFIdsToJSONTyped(json, false);
}

export function GUFIdsToJSONTyped(
  value?: Omit<GUFIds, "uuid"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    data_owner: value["dataOwner"],
  };
}
